import { LanguageSelectorFeatureFlagsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useLanguageSelectorFeatures = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { loading, data } = useQuery(LanguageSelectorFeatureFlagsDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      companyId,
    },
  })

  const features = data?.features.featuresConnection.nodes ?? []

  const inContextLocalization =
    features.find((feature) => feature.name === 'in_context_localization')?.enabled ?? false

  const greekLanguage =
    features.find((feature) => feature.name === 'greek_language')?.enabled ?? false

  const ngoLocale = features.find((feature) => feature.name === 'ngo_locale')?.enabled ?? false

  return {
    loading,
    inContextLocalization,
    greekLanguage,
    ngoLocale,
  }
}
